export default {
  header: 'Password reset',
  input: 'Your email address',
  success: 'Email with password change link was sent to your email box.'
}



// WEBPACK FOOTER //
// ./src/i18n/en/components/resetPassword.js